import { useState } from "react";
import AppContext from "./AppContext";

function AppState(props){
    const [beaconData, setBeaconData] = useState({})
    const [location , setLocation] = useState([])
    const [gateway , setGateway] = useState([])
    const [category , setCategory] = useState([])
    const [asset , setAsset] = useState([])
    const [socketData , setSocketData] = useState([])
    const [notification , setNotification] = useState([])
    const [userRole, setUserRole] = useState({})
    const [loading, setLoading] = useState(false)
    const [loadingAssets, setLoadingAssets] = useState(false)



    return (
        <AppContext.Provider value={{ beaconData,setLoadingAssets, loadingAssets, setLoading, loading ,setUserRole, setBeaconData, category, setCategory, location, setLocation, setGateway, gateway, setAsset, asset, check: 'passed', setSocketData, socketData,userRole, setNotification, notification}}>
             {props.children}
        </AppContext.Provider>
    )
}

export default AppState